import { useState } from 'react';
import './add-to-cart-btn.css'; 
const AddToCart = ({ forService , add, remove, cart }) => {
    const itemCount = forService.id in cart ? cart[forService.id].quantity : 0
    const [cartCount, setCartCount] = useState(itemCount)
    const incrementCount = () => {
        setCartCount(c => c + 1)
        add(forService.id, setCartCount)
    }
    const decrementCount = () => {
        setCartCount(c => c - 1)
        remove(forService.id)
    }
    return (
        <div className="add-to-cart__counter">
            {cartCount > 0 ? <span className="decrement-button" onClick={decrementCount}>-</span> : ""}
            {cartCount > 0 ? <span className="cart-item-count">{cartCount}</span> : <span className="empty-item" onClick={incrementCount}>Add</span>}
            <span className="increment-button" onClick={incrementCount}>+</span>
        </div>
    )
}

export default AddToCart;